// @vendors
const Immutable = require('immutable');
const momentTz = require('moment-timezone');
const get = require('lodash/object/get');
const trim = require('lodash/string/trim');

// @helpers
const actionTypes = require('constants/actionTypes');
const apiURLBuilder = require('core/apiURLBuilder');
const { getCCOfficeChannel } = require('utilities/contactCenter/printerHelper');
const translateExantCostKey = require('utilities/translationExantCost');

const { es: { DATE_FORMAT_WITH_DASHES_DATETIME }} = require('commonsConstants/dateFormatTypes');
const {
    FIRST_STEP,
    SECOND_STEP,
    WIZARD_FIRST_STEP,
    WIZARD_SECOND_STEP,
    DATE_FORMAT_API,
    BROKER_ORDER_TYPE_TO_MARKET,
    BROKER_ORDER_TYPE_LIMITED,
    BROKER_ORDER_TYPE_FOR_THE_BEST,
    EURO_TEXT,
    BROKER_RIGHTS_SELL_CORPORATE_OPERATION,
    BROKER_TYPE_RIGHT_NEW_DECIMALS,
    FOR_THE_BEST_CODE,
    LIMITED_CODE,
    TO_MARKET_CODE,
    CHARGE_ACCOUNT_PREFIX,
    CONNECTION_CHANNEL_INTERNET,
    BROKER_ORDER_TYPE_SELL,
    BROKER_CORPORATE_OPERATIONS_RIGHTS_PRODUCT_TYPE,
    BROKER_ORDER_TYPE_FOR_THE_BEST_DESCRIPTION,
    BROKER_ORDER_TYPE_LIMITED_DESCRIPTION,
    BROKER_ORDER_TYPE_TO_MARKET_DESCRIPTION,
    BROKER_MIFID_RIGHTS_PDF_AMOUNT_DECIMALS,
    API_CHANNEL
} = require('constants/index');
const { RIGHTS_SELL_SHOW_COST } = require('constants/flagBasedFeatures');

// @actions
const signaturePatternActions = require('actions/signaturePattern');
const errorActions = require('actions/brokerError');

// @ utilities
const { APIPost } = require('utilities/APIRequestHelper');
const DateHelper = require('utilities/dateHelper');
const PersonalDataHelper = require('utilities/personalDataHelper');
const { getConfirmationPDFSharesAmount } = require('utilities/pdfDocumentsHelper');

function selectedCorporateOperationIndexChanged(value) {
    return {
        type: actionTypes.BROKER_RIGHTS_SELL_SELECTED_CORPORATE_INDEX_CHANGED,
        payload: {
            value
        }
    };
}

function rightsQuantityChanged(value) {
    return {
        type: actionTypes.BROKER_RIGHTS_SELL_RIGHTS_QUANTITY_CHANGED,
        payload: {
            value
        }
    };
}

function validityDateChanged(value) {
    return {
        type: actionTypes.BROKER_RIGHTS_SELL_VALIDITY_DATE_CHANGED,
        payload: {
            value
        }
    };
}

function orderTypeChanged(value) {
    return {
        type: actionTypes.BROKER_RIGHTS_SELL_ORDER_TYPE_CHANGED,
        payload: {
            value
        }
    };
}

function limitedValueChanged(value) {
    return {
        type: actionTypes.BROKER_RIGHTS_SELL_LIMITED_VALUE_CHANGED,
        payload: {
            value
        }
    }
}

function reset() {
    return {
        type: actionTypes.BROKER_RIGHTS_SELL_RESET
    };
}

const setVisibleStep = step => ({
    type: actionTypes.BROKER_RIGHTS_SELL_SET_VISIBLE_STEP,
    payload: {
        step
    }
});

const validateUIStep = (step, catalogData) => ({
    type: actionTypes.BROKER_RIGHTS_SELL_VALIDATE_UI_STEP,
    payload: {
        step,
        catalogData
    }
});

function confirmRightsBuyRequest() {
    return {
        type: actionTypes.BROKER_RIGHTS_SELL_CONFIRM_REQUEST
    };
}

function confirmRightsBuySuccess(response) {
    return {
        type: actionTypes.BROKER_RIGHTS_SELL_CONFIRM_SUCCESS,
        payload: {
            orderNumber: response.numeroOrden
        }
    };
}

function confirmRightsBuyFailure(response) {
    return {
        type: actionTypes.BROKER_RIGHTS_SELL_CONFIRM_FAILURE,
        payload: {
            data: response
        }
    };
}

const getOrderTypeCode = (orderType) => {
    let result;

    switch (orderType) {
        case BROKER_ORDER_TYPE_TO_MARKET:
            result = TO_MARKET_CODE;
            break;
        case BROKER_ORDER_TYPE_LIMITED:
            result = LIMITED_CODE;
            break;
        case BROKER_ORDER_TYPE_FOR_THE_BEST:
            result = FOR_THE_BEST_CODE;
            break;
    }

    return result;
};

const getConfirmationRequestObject = (dataToken, getState) => {
    const immBrokerRightsSell = getState().brokerRightsSell;
    const immBrokerProductFile = getState().brokerProductFile;
    const immCorporatesOperations = getState().brokerCorporatesOperations;
    const immBrokerLegalDocumentation = getState().brokerLegalDocumentation;
    const uuid = immBrokerLegalDocumentation.get('uuid');
    const selectedCorporateOperationIndex = immBrokerRightsSell.get(
        'selectedCorporateOperationIndex'
    );
    const selectedCorporateOperation = immCorporatesOperations.getIn([
        'selectedContract',
        'operations',
        selectedCorporateOperationIndex
    ]);
    const selectedContract = immCorporatesOperations.get('selectedContract');
    const validityDate = immBrokerRightsSell.getIn(['steps', FIRST_STEP, 'validityDate']);
    const orderTypeOption = immBrokerRightsSell.getIn(['steps', FIRST_STEP, 'orderTypeOption']);
    const lastProductPrice = immBrokerProductFile.getIn(['productValue', 'amount']);
    const rightsQuantity = immBrokerRightsSell.getIn(['steps', FIRST_STEP, 'rightsQuantity']);
    const shares = Number(rightsQuantity) || 0;

    const requestObject = {
        header: {
            version: 2
        },
        query: {
            initQuantity: shares,
            unitPrice: Number(lastProductPrice) || 0,
            productIsin: trim(selectedCorporateOperation.get('isin')),
            accionesSuscrita: 0,
            codigoEmision: trim(selectedCorporateOperation.get('codigoEmision')),
            codigoEntidadFinanciera: trim(immBrokerRightsSell.getIn(['validationServiceResponse', 'codigoEntidadFinanciera'])),
            codigoValor: trim(selectedCorporateOperation.get('codigoValorInterno')),
            contrato: {
                numerodecontrato: trim(selectedContract.getIn(['contract', 'number'])),
                producto: trim(selectedContract.getIn(['contract', 'product']))
            },
            dataToken,
            digitoDeControl: trim(selectedContract.getIn(['cuenta', 'digitodecontrol'])),
            fechaApertura: trim(immBrokerRightsSell.getIn(['validationServiceResponse', 'fechaApertura'])),
            fechaSesion: DateHelper.formatDate(new Date(), DATE_FORMAT_API),
            formaPago: trim(immBrokerRightsSell.getIn(['validationServiceResponse', 'formaPago'])),
            horaNegociacion: trim(immBrokerRightsSell.getIn(['validationServiceResponse', 'horaNegociacion'])),
            micCode: trim(selectedCorporateOperation.get('iso')),
            numDerechosValMin: 0,
            numeroDerechos: Number(rightsQuantity),
            plazoValidez: DateHelper.formatDate(validityDate, DATE_FORMAT_API),
            proporcionTitulosNuevos: trim(immBrokerRightsSell.getIn(['validationServiceResponse', 'proporcionTitulosNuevos'])),
            proporcionTitulosViejos: trim(immBrokerRightsSell.getIn(['validationServiceResponse', 'proporcionTitulosViejos'])),
            tipoEjecucion: trim(immBrokerRightsSell.getIn(['validationServiceResponse', 'tipoEjecucion'])),
            tipoOperacion: BROKER_RIGHTS_SELL_CORPORATE_OPERATION,
            tipoOrden: getOrderTypeCode(orderTypeOption),
            documentationId: uuid
        }
    };

    if (orderTypeOption === BROKER_ORDER_TYPE_LIMITED) {
        requestObject.query.importeLimitado = {
            divisa: EURO_TEXT,
            numeroimportevalores: immBrokerRightsSell.getIn(['steps', FIRST_STEP, 'orderTypeValue']).toFixed(BROKER_TYPE_RIGHT_NEW_DECIMALS)
        };
    }
    return requestObject;
};

const generateMiFIDDisclaimers = (immBrokerConvenienceMiFIDTest) => {
    const immUSPersonDisclaimers = immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'usPersonDisclaimers']);
    const immDisclaimers = immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'disclaimers']);
    const immAllDisclaimers = Immutable.fromJS([]).merge(immUSPersonDisclaimers).merge(immDisclaimers);

    return immAllDisclaimers.map(immDisclaimer => immDisclaimer.get('description')).join(' | ');
};

const getOrderConditionDescription = orderTypeOption => {
    let description = '';

    switch(orderTypeOption) {
        case BROKER_ORDER_TYPE_FOR_THE_BEST:
            description = BROKER_ORDER_TYPE_FOR_THE_BEST_DESCRIPTION;
            break;
        case BROKER_ORDER_TYPE_LIMITED:
            description = BROKER_ORDER_TYPE_LIMITED_DESCRIPTION;
            break;
        case BROKER_ORDER_TYPE_TO_MARKET:
            description = BROKER_ORDER_TYPE_TO_MARKET_DESCRIPTION;
            break;
        default:
            break;
    }

    return description;
}

const storeDocument = (sellRightsResponse, history) => (dispatch, getState) => {
    const immProfile = getState().profile;
    const immCorporatesOperations = getState().brokerCorporatesOperations;
    const immBrokerRightsSell = getState().brokerRightsSell;
    const immBrokerProductFile = getState().brokerProductFile;
    const immFlagBasedFeatures = getState().flagBasedFeatures;

    const selectedCorporateOperationIndex = immBrokerRightsSell.get('selectedCorporateOperationIndex');
    const immContract = immCorporatesOperations.get('selectedContract');
    const immOperation = immCorporatesOperations.getIn([
        'selectedContract',
        'operations',
        selectedCorporateOperationIndex
    ]);

    const orderId = trim(get(sellRightsResponse, 'numeroOrden'));
    const orderTimestamp =
        get(sellRightsResponse, 'timestamp') ||
        get(sellRightsResponse, 'timeResponse.timestamp');

    const momentEmittedDateTime = momentTz(Number(orderTimestamp)).tz("Europe/Madrid");

    const controlDigit = trim(immContract.getIn(['cuenta', 'digitodecontrol']));
    const productNumber = trim(immContract.getIn(['contract', 'product']));
    const contractNumber = trim(immContract.getIn(['contract', 'number']));
    const idContract = `${CHARGE_ACCOUNT_PREFIX}${controlDigit}${productNumber}${contractNumber}`;

    const owner = trim(immContract.get('owner'));
    const validityDate = immBrokerRightsSell.getIn(['steps', FIRST_STEP, 'validityDate']);
    const orderTypeOption = immBrokerRightsSell.getIn(['steps', FIRST_STEP, 'orderTypeOption']);

    const rightsQuantity = immBrokerRightsSell.getIn(['steps', FIRST_STEP, 'rightsQuantity']);
    const sharesNumber = Number(rightsQuantity) || 0;
    const orderTypeValue = immBrokerRightsSell.getIn(['steps', FIRST_STEP, 'orderTypeValue']);
    const isLimitedOrder = orderTypeOption === BROKER_ORDER_TYPE_LIMITED;

    const marketName = (__CONTACT_CENTER__ && trim(immBrokerProductFile.get('manager', ''))) || trim(immBrokerProductFile.get('marketName', ''));
    const productAmount = Number(immBrokerProductFile.getIn(['productValue','amount'])) || 0;
    const currency = (immBrokerProductFile.getIn(['productValue','currency']))
    const sharesAmount = getConfirmationPDFSharesAmount({
        isLimitedOrder,
        sharesNumber,
        lastPrice: productAmount,
        decimals: BROKER_MIFID_RIGHTS_PDF_AMOUNT_DECIMALS
    });

    const exAnteData =
        immFlagBasedFeatures.get(RIGHTS_SELL_SHOW_COST) &&
        !!immBrokerRightsSell.get("exAnteData")
            ? translateExantCostKey(
                immBrokerRightsSell.get("exAnteData").toJS(),
                "brokerRightsSell"
            ) : null;

    const query = {
        productKID: '',
        contract: '',
        marketingReport: '',
        infoCcv: '',
        sendOrder: 'No',
        idOrder: orderId,
        market: marketName,
        termValidity: validityDate.format(DATE_FORMAT_API),
        holders: owner,
        leafletSusbcription: trim(immOperation.get('linkTriptico')),
        cnmvDocumentation: trim(immOperation.get('linkCNMV')),
        ccv: idContract, // franco.montenegro To confirm
        ccc: trim(get(sellRightsResponse, 'cuentaAsociada.codbban')), // franco.montenegro To confirm
        idContract: idContract, // franco.montenegro To confirm
        email: trim(PersonalDataHelper.getEmail(immProfile)),
        clientAlias: trim(immProfile.get('nombreCliente')),
        isin: trim(immOperation.get('isin')),
        isinDescribe: trim(immOperation.get('descriptionValue')),
        channel: CONNECTION_CHANNEL_INTERNET,
        orderType: BROKER_ORDER_TYPE_SELL,
        productType: BROKER_CORPORATE_OPERATIONS_RIGHTS_PRODUCT_TYPE,
        sharesNumber,
        sharesAmount,
        orderCondition: getOrderConditionDescription(orderTypeOption),
        conditionPrize : orderTypeValue ? `${orderTypeValue}` : '',
        currency: currency,
        mifidWarningText: generateMiFIDDisclaimers(getState().brokerConvenienceMiFIDTest),
        dateTime: momentEmittedDateTime.format(DATE_FORMAT_WITH_DASHES_DATETIME),
        exAnteCostsList: exAnteData,
    };

    const url = apiURLBuilder.getURL('communication');

    APIPost(dispatch, url, { query }).catch(() => dispatch(errorActions.show('', true, history)));
}

function confirmOrder(dataToken, history) {
    return function(dispatch, getState) {
        const data = getConfirmationRequestObject(dataToken, getState);

        dispatch(confirmRightsBuyRequest());
        return APIPost(dispatch, apiURLBuilder.getURL('brokerRightsBuyConfirmation'), data).then(
            function(response) {
                dispatch(confirmRightsBuySuccess(response));
                dispatch(storeDocument(response, history));
            },
            function(response) {
                dispatch(confirmRightsBuyFailure(response));
                const errorKey = get(response, ['body', 'error'], '');
                dispatch(errorActions.show('brokerAPIErrors-' + errorKey, true, history));
            }
        );
    };
}

const validateSignaturePattern = (history) => (dispatch, getState) => {
    const callback = (dispatch, getState, dataToken) => {
        dispatch(confirmOrder(dataToken, history));
    };
    signaturePatternActions.validateAndExecute(dispatch, getState, callback);
};

function validateWithAPIRequest(step) {
    return {
        type: actionTypes.BROKER_RIGHTS_SELL_VALIDATE_REQUEST,
        payload: {
            step
        }
    };
}

function validateWithAPISuccess(step, response) {
    return {
        type: actionTypes.BROKER_RIGHTS_SELL_VALIDATE_SUCCESS,
        payload: {
            data: response,
            step
        }
    };
}

function validateWithAPIFailure(step, response) {
    return {
        type: actionTypes.BROKER_RIGHTS_SELL_VALIDATE_FAILURE,
        payload: {
            data: response,
            step
        }
    };
}

const getValidationRequestObject = getState => {
    const immBrokerRightsSell = getState().brokerRightsSell;
    const immCorporatesOperations = getState().brokerCorporatesOperations;
    const selectedCorporateOperationIndex = immBrokerRightsSell.get(
        'selectedCorporateOperationIndex'
    );
    const selectedCorporateOperation = immCorporatesOperations.getIn([
        'selectedContract',
        'operations',
        selectedCorporateOperationIndex
    ]);
    const selectedContract = immCorporatesOperations.get('selectedContract');
    const validityDate = immBrokerRightsSell.getIn(['steps', FIRST_STEP, 'validityDate']);
    const orderTypeOption = immBrokerRightsSell.getIn(['steps', FIRST_STEP, 'orderTypeOption']);

    const requestObject = {
        query: {
            codigoEmision: selectedCorporateOperation.get('codigoEmision'),
            codigoValor: selectedCorporateOperation.get('codigoValorInterno'),
            contrato: {
                numerodecontrato: selectedContract.getIn(['contract', 'number']),
                producto: selectedContract.getIn(['contract', 'product'])
            },
            moduloDepositanteDigito: selectedContract.getIn(['cuenta', 'digitodecontrol']),
            numeroDerechos: immBrokerRightsSell.getIn(['steps', FIRST_STEP, 'rightsQuantity']),
            plazoValidez: DateHelper.formatDate(validityDate, DATE_FORMAT_API),
            tipoOperacion: BROKER_RIGHTS_SELL_CORPORATE_OPERATION,
            tipoOrden: getOrderTypeCode(orderTypeOption)
        }
    };

    if (orderTypeOption === BROKER_ORDER_TYPE_LIMITED) {
        requestObject.query.precioLimite = {
            divisa: EURO_TEXT,
            importe: immBrokerRightsSell.getIn(['steps', FIRST_STEP, 'orderTypeValue']).toFixed(4)
        };
    }

    return requestObject;
};

const validateWithAPI = (step, history) => (dispatch, getState) => {
    const valid = getState().brokerRightsSell.getIn(['steps', FIRST_STEP, 'valid']);

    if (valid) {
        const data = getValidationRequestObject(getState);

        dispatch(validateWithAPIRequest(step));
        return APIPost(dispatch, apiURLBuilder.getURL('brokerRightsSellValidation'), data).then(
            function(response) {
                dispatch(validateWithAPISuccess(step, response));
            },
            function(response) {
                dispatch(validateWithAPIFailure(step, response));
                const errorKey = get(response, ['body', 'error'], '');
                dispatch(errorActions.show('brokerAPIErrors-' + errorKey, true, history));
            }
        );
    }
};

const validateStep = (step, history) => (dispatch, getState) => {
    const catalogData = getState().brokerProductFile.get('catalogData');
    dispatch(validateUIStep(step, catalogData));
    switch (step) {
        case WIZARD_FIRST_STEP:
            dispatch(validateWithAPI(step, history));
            break;
        case WIZARD_SECOND_STEP:
            const valid = getState().brokerRightsSell.get('steps').get(SECOND_STEP).get('valid');
            if (valid) {
                dispatch(validateSignaturePattern(history));
            }
            break;
    }
};

const toggleDisclaimerCheckbox = evt => ({
    type: actionTypes.BROKER_RIGHTS_SELL_DISCLAIMER_CLAUSE_CHANGED,
    payload: {
        checked: evt.target.checked
    }
});

const setWillCancel = willCancel => ({
    type: actionTypes.BROKER_RIGHTS_SELL_WILL_CANCEL,
    payload: {
        willCancel
    }
});

const finish = () => () => {};

const setDocumentsRead = () => (dispatch) => dispatch({
    type: actionTypes.BROKER_RIGHTS_SELL_DOCUMENTS_READ
});

function getExAnteDataSuccess(response) {
    return {
        type: actionTypes.BROKER_RIGHTS_SELL_EX_ANTE_SUCCESS,
        payload: {
            data: response
        }
    };
}
function getExAnteDataFailure() {
    return {
        type: actionTypes.BROKER_RIGHTS_SELL_EX_ANTE_FAILURE,
    };
}
function getExAnteDataFetching() {
    return {
        type: actionTypes.BROKER_RIGHTS_SELL_EX_ANTE_FETCHING,
    };
}

const getExAnteData = (history) => (dispatch, getState) => {
    const immRightSellStep1 = getState().brokerRightsSell.getIn(['steps', FIRST_STEP]);
    const immCorporatesOperations = getState().brokerCorporatesOperations;
    const immBrokerProductFile = getState().brokerProductFile;
    const selectedContract =  immCorporatesOperations.get('selectedContract');
    const isinCode = immBrokerProductFile.get('isinCode');
    const shares = immRightSellStep1.get('rightsQuantity');
    const orderTypeOption = immRightSellStep1.get('orderTypeOption');
    const productCurrency = immBrokerProductFile.getIn(['productValue','currency']);
    let limitedPrice, orderType;
    switch (orderTypeOption) {
        case BROKER_ORDER_TYPE_TO_MARKET:
            limitedPrice = null;
            orderType = "MARKET";
            break;
        case BROKER_ORDER_TYPE_FOR_THE_BEST:
            limitedPrice = null;
            orderType = "BEST";
            break;
        case BROKER_ORDER_TYPE_LIMITED:
        default:
            limitedPrice = {
                amount: immRightSellStep1.get("orderTypeValue"),
                currency: productCurrency,
            }
            orderType = "LIMITED";
        break;
    }
    const requestData = {
        channel: __CONTACT_CENTER__ ? getCCOfficeChannel() : API_CHANNEL,
        contract: {
            number: selectedContract.getIn(['contract', 'number']),
            product: selectedContract.getIn(['contract', 'product'])
        },
        instrumentType: 'RIGHT',
        isin: isinCode,
        limitedPrice: limitedPrice,
        market: immBrokerProductFile.get('micCode'),
        operationType: 'V',
        orderType: orderType,
        sharesAmount: null,
        sharesNumber: shares,
    };

    const data = {
        query: requestData
    }

    dispatch(getExAnteDataFetching());
    return APIPost(dispatch, apiURLBuilder.getURL('brokerGetExAnteCost'), data)
        .then(response => dispatch(getExAnteDataSuccess(response)))
        .catch(error => {
            const errorKey = get(error, ['body', 'error'], '');
            dispatch(getExAnteDataFailure());
            dispatch(errorActions.show('brokerAPIErrors-' + errorKey, true, history));
        })
}


module.exports = {
    finish,
    limitedValueChanged,
    orderTypeChanged,
    reset,
    rightsQuantityChanged,
    selectedCorporateOperationIndexChanged,
    toggleDisclaimerCheckbox,
    setVisibleStep,
    setWillCancel,
    validateStep,
    validityDateChanged,
    setDocumentsRead,
    getExAnteData,
};
